module.exports = __webpack_public_path__ + "./images/b197b4ded3c61debcb41e1455886f468.webp";